import { chunkArray } from '~/utils/chunkArray';

export type SelectedVoucherUser = { voucherUserId: string; voucherId: string; userId: string };

export function createVoucherUserBulkBatches(selected: Array<SelectedVoucherUser>, batchSize: number) {
  const byVoucher = new Map<string, Set<string>>();
  for (const row of selected) {
    const userIds = byVoucher.get(row.voucherId) ?? new Set<string>();
    userIds.add(row.userId);
    byVoucher.set(row.voucherId, userIds);
  }
  return [...byVoucher].flatMap(([voucherId, userIds]) =>
    chunkArray([...userIds], batchSize).map((page) => ({ voucherId, userIds: page })),
  );
}
